export const globalDictionary = {
    'de': {
        'Incorrect username or password.': "Das Kennwort ist nicht korrekt.",
        'User does not exist.': "Benutzer konnte nicht gefunden werden.",
        'Invalid verification code provided, please try again.': "Der Bestätigungscode inst ungültig, bitte versuche es erneut.",
        "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": 'Das Passwort musst mindestens 8-stellig sein und eine Nummer und sowohl Groß als auch Kleinschreibung enthalten',
        'An account with the given email already exists.': "Ein Benutzer mit der angegebenen Emailadresse exisitiert bereits.",
        'User is not confirmed.': "Der Benutzer ist noch nicht bestätigt.",
    }
}